import i18n from 'utils/i18n'
import type { AdminMentionsFactsFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  RADIO_LIST,
  RHEOSTAT,
  SEARCH_USERS,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationMentionsFactsFiltersCollection = () => [
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.merchantNameFilter),
    filterName:
      ADMIN_FILTERS_NAME.merchantFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.merchantFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.mentionImages),
    filterName:
      ADMIN_FILTERS_NAME.mentionImages satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.mentionImages,
  },
  {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(ADMIN_FILTERS_TITLE.confidenceFilter),
    filterName:
      ADMIN_FILTERS_NAME.confidenceFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.modelFactsConfidenceFilter,
    maxFraction: 100000,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.modelVersionFilter),
    filterName:
      ADMIN_FILTERS_NAME.modelVersionFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.modelVersionFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.aiFactsFilter),
    filterName:
      ADMIN_FILTERS_NAME.aiFactsFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.aiFactsFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.userFactsFilter),
    filterName:
      ADMIN_FILTERS_NAME.userFactsFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.userFactsFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.diffFieldsFilter),
    filterName:
      ADMIN_FILTERS_NAME.diffFieldsFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.factsDiffFieldsFilter,
    notUseLastUpdatedFilter: true,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.grapesFactFilter),
    filterName:
      ADMIN_FILTERS_NAME.grapesFactFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.grapesFactFilter,
  },
  {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(ADMIN_FILTERS_TITLE.alcoholFactFilter),
    filterName:
      ADMIN_FILTERS_NAME.alcoholFactFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.alcoholFactFilter,
    maxFraction: 100000,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.certsFactFilter),
    filterName:
      ADMIN_FILTERS_NAME.certsFactFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.certsFactFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.awardsFactFilter),
    filterName:
      ADMIN_FILTERS_NAME.awardsFactFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.awardsFactFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineCountryFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineCountryFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.productCountryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.producerFilter),
    filterName:
      ADMIN_FILTERS_NAME.producerFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.tradeNameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.productBrandFilter),
    filterName:
      ADMIN_FILTERS_NAME.productBrandFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.productBrandFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.additionalNameFilter),
    filterName:
      ADMIN_FILTERS_NAME.additionalNameFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.additionalNameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.nationalGITypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.nationalGITypeFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.nationalGITypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.geoIndicationFilter),
    filterName:
      ADMIN_FILTERS_NAME.geoIndicationFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.geoIndicationFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.specialClassificationFilter),
    filterName:
      ADMIN_FILTERS_NAME.specialClassificationFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.specialClassificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineTypeFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.wineTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineColourFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineColourFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.wineColourFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.sweetnessTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.sweetnessTypeFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.sweetnessTypeFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.vintageFilter),
    filterName:
      ADMIN_FILTERS_NAME.vintageFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.factVintageFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.bottleSizeFilter),
    filterName:
      ADMIN_FILTERS_NAME.bottleSizeFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.factSizeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.packageTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.packageTypeFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.factPackageTypesFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.aiFactsDateFilter),
    filterName:
      ADMIN_FILTERS_NAME.aiFactsDateFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.modelFactsCreatedAtFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.userEntitiesFilter),
    filterName:
      ADMIN_FILTERS_NAME.userEntitiesFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.userEntitiesFilter,
    withCheckAll: true,
  },
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.creationUserFilter),
    filterName:
      ADMIN_FILTERS_NAME.authorUserFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.authorUserFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.createdAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.createdAtFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.createdAtFilter,
  },
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.verificationUserFilter),
    filterName:
      ADMIN_FILTERS_NAME.verificationUserFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.moderatorFactsUsernameFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.verificatedAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.verificatedAtFilter satisfies AdminMentionsFactsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.moderatorFactsCreatedAtFilter,
  },
]

export const adminMentionsFactsFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationMentionsFactsFiltersCollection,
  pathToStore: [],
  filtersDataPath: ['admin', 'mentions', 'mentionsFilters'],
  showResultsTextKey: 'filters.button.apply',
  withShare: true,
  showPresets: false,
}
